module.exports = __webpack_public_path__ + "331f64906b167e2e1b54021afc8be36f.png";